import axios from "axios";
import Config from "../Config";

export async function get_user() {
  let response = await axios.get(Config.BACKEND_ADDR + "/auth/me");
  let userData = response.data;

  let lessons = userData.lessons.map((el) => {
    return {
      student_id: el.student_id,
      studentName: el.student_name,
      student_photo: el.student_photo,
      time: el.time,
      start_time: el.start_time,
      payedLessons: el.payed_lessons,
      weekday: el.weekday,
    };
  });
  console.log("userDataRaw", userData);
  return {
    id: userData.id,
    image: userData.image,
    name: userData.full_name,
    email: userData.email,
    phoneNumber: userData.phone_number,
    newPassword: null,
    newPasswordRepeat: null,
    total_lessons: userData.total_lessons,
    balance: userData.balance,
    nextLessonIn: userData.next_lesson_in,
    lessonsList: lessons,
    endOfSubscriptionTime: userData.paid_until,
    paid_until: userData.paid_until,
    tariff: userData.tariff,
    referal_code: userData.referal_code,
    rebillid: userData.rebillid,
    card_id: userData.card_id,
    pan: userData.pan,
    exp_date: userData.exp_date,
    time_zone: userData.time_zone,
    unread_changes_count: userData.unread_changes_count,
  };
}
